import { render, staticRenderFns } from "./indexLayout.vue?vue&type=template&id=64fe6142&"
import script from "./indexLayout.vue?vue&type=script&lang=js&"
export * from "./indexLayout.vue?vue&type=script&lang=js&"
import style0 from "./indexLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports